import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_garmin_daily_spo2 extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_garmin_daily_spo2').getContext('2d');
        const date = this.props.data[0]['timeoffsetsleepspo2'];
        const data = this.props.data[0]['timeoffsetsleepspo2'];
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length; i++) {
            x_data.push(data[i][1]);
            var tmp = format(new Date(date[i][0]), "HH:mm");
            y_data.push(tmp);
        }
        console.log(y_data)
        var isstepped = false;
        if (window.Chart_garmin_daily_spo2 instanceof Chart) window.Chart_garmin_daily_spo2.destroy();
        window.Chart_garmin_daily_spo2 = new Chart(ctx, {
            type: "line",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'SpO2 (%)',
                        data: x_data,
                        steppedLine: isstepped,
                        backgroundColor: '#ffffff',
                        borderColor: '#cc7000',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            format: "HH:mm",
                            unit: 'minute',
                            unitStepSize: 1,
                            displayFormats: {
                                'minute': 'HH:mm',
                                'hour': 'HH:mm'
                            }
                        }
                    }]
                },
                elements: {
                    point: {
                        radius: 2.5
                    }
                },
                title: {
                    display: false,
                    text: "Daily SpO2",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_garmin_daily_spo2"></canvas>
            </div>
        );
    }
}